import React, { Component } from "react";
import { firebase } from "../firebase/db";

import Modal from "react-bootstrap/Modal";
import PrintProvider, { Print, NoPrint } from "react-easy-print";
import StudentDetails from "./studentDetails";
import { Spinner } from "reactstrap";
import $ from "jquery";
import { findDOMNode } from "react-dom";

class Addmission extends Component {
  state = {
    addmissiontype: "Select",
    course: "Select",
    name: " ",
    f_name: "",
    m_name: " ",
    b_day: "  ",
    nationality: "Select",
    occopation: "",
    address: "",
    tel: "",
    cell: "",
    email: "",
    p_address: "",
    ssc_p_year: "",
    ssc_institute: "",
    ssc_gpa: "",
    hsc_p_year: "",
    hsc_institute: "",
    hsc_gpa: "",
    languageProf: "",
    language_proficiency: "",
    study_japanese: "",
    profile: null,
    moneyReceipt: null,
    done: false,
    Spinner: false,
    selectCourse: false
  };
  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
    if (e.target.value === "Ikebana") {
      this.setState({ selectCourse: true });
    }
    if (e.target.value === "Language" || e.target.value === "Select") {
      this.setState({ selectCourse: false });
    }
  };

  pushData = async () => {
    this.setState({ Spinner: true });
    var UpdatedUser = {
      addmissiontype: this.state.addmissiontype,
      course: this.state.course,
      name: this.state.name,
      f_name: this.state.f_name,
      m_name: this.state.m_name,
      b_day: this.state.b_day,
      nationality: this.state.nationality,
      occopation: this.state.occopation,
      address: this.state.address,
      tel: this.state.tel,
      cell: this.state.cell,
      email: this.state.email,
      p_address: this.state.p_address,
      ssc_p_year: this.state.ssc_p_year,
      ssc_institute: this.state.ssc_institute,
      ssc_gpa: this.state.ssc_gpa,
      hsc_p_year: this.state.hsc_p_year,
      hsc_institute: this.state.hsc_institute,
      hsc_gpa: this.state.hsc_gpa,
      languageProf: this.state.languageProf,
      language_proficiency: this.state.language_proficiency,
      study_japanese: this.state.study_japanese
    };
    const storage = firebase.storage();
    let name = Math.floor(Math.random() * 100000000);
    if (this.state.profile) {
      var store = storage.ref(`userImage/${name}`);
      await store.put(this.state.profile).then(async () => {
        await store.getDownloadURL().then(downloadURL => {
          UpdatedUser.user_pic = downloadURL;
          UpdatedUser.user_thumb = downloadURL;
        });
      });
    }
    let recipetName = Math.floor(Math.random() * 100000000);
    if (this.state.profile) {
      var store = storage.ref(`userImage/${recipetName}`);
      await store.put(this.state.moneyReceipt).then(async () => {
        await store.getDownloadURL().then(downloadURL => {
          UpdatedUser.moneyReceipt_pic = downloadURL;
          UpdatedUser.cusmoneyReceipt_thumb = downloadURL;
        });
      });
    }
    if (UpdatedUser.user_pic && UpdatedUser.moneyReceipt_pic) {
      const firestore = firebase.firestore();
      const ref = firestore.collection("addmissionforms").doc(this.state.cell);
      ref
        .set({
          ...UpdatedUser,
          status: "painding"
        })
        .then(snap => {
          this.setState({ done: true, Spinner: false });
        })
        .catch(err => console.log(err));
    }
  };

  handleSubmit = e => {
    e.preventDefault();

    if (this.state.addmissiontype === "Ikebana") {
      if (this.state.nationality === "Select") {
        alert("Must Select Nationality");
      } else {
        if (this.state.profile === null && this.state.moneyReceipt === null) {
          alert("Must uplode your image and moneyReceipt");
        } else {
          var profileImg = document.querySelector("#profile");
          var profileImgWidth = profileImg.naturalWidth;
          var profileImgHeight = profileImg.naturalHeight;
          var moneReceiptImg = document.querySelector("#moneyReceipt");
          var moneReceiptImgWidth = moneReceiptImg.naturalWidth;
          var moneReceiptImgHeight = moneReceiptImg.naturalHeight;
          if (profileImgWidth > 300 || profileImgHeight > 300) {
            alert("Too Large Image ");
          } else if (moneReceiptImgWidth > 400 || moneReceiptImgHeight > 400) {
            alert("Money Receipt Image too Large");
          } else {
            //console.log(profileImgWidth);
            this.pushData();
          }
        }
      }
    } else {
      if (
        this.state.addmissiontype === "Select" ||
        this.state.addmissiontype === "Language"
      ) {
        if (
          this.state.course === "Select" ||
          this.state.nationality === "Select"
        ) {
          alert("Must Select  addmissiontype ,course and nationality");
        } else {
          if (this.state.profile === null && this.state.moneyReceipt === null) {
            alert("Must uplode your image and moneyReceipt");
          } else {
            var profileImg = document.querySelector("#profile");
            var profileImgWidth = profileImg.naturalWidth;
            var profileImgHeight = profileImg.naturalHeight;
            var moneReceiptImg = document.querySelector("#moneyReceipt");
            var moneReceiptImgWidth = moneReceiptImg.naturalWidth;
            var moneReceiptImgHeight = moneReceiptImg.naturalHeight;
            if (profileImgWidth > 600 || profileImgHeight > 600) {
              alert("Profile  Image too Large");
            } else if (
              moneReceiptImgWidth > 600 ||
              moneReceiptImgHeight > 600
            ) {
              alert("Money Receipt Image too Large");
            } else {
              //console.log(profileImgWidth);
              this.pushData();
            }
          }
        }
      }
    }
  };

  onProfilePicChange = event => {
    if (event.target.files[0].type.indexOf("image") == -1) {
      alert("file must be an Image");
    } else {
      this.setState({ [event.target.name]: event.target.files[0] });
    }
  };

  handlePrint = e => {
    window.print();
  };
  handleModelClose = e => {
    this.setState({ done: false });
  };

  handleImgChange = e => {
    var myImg = document.querySelector("#file");
    var realWidth = myImg.naturalWidth;
    var realHeight = myImg.naturalHeight;
    alert(
      "Original width=" + realWidth + ", " + "Original height=" + realHeight
    );
  };

  render() {
    const profile =
      this.state.profile !== null
        ? URL.createObjectURL(this.state.profile)
        : null;
    const moneyReceipt =
      this.state.moneyReceipt !== null
        ? URL.createObjectURL(this.state.moneyReceipt)
        : null;

    const spinner = this.state.Spinner ? (
      <div>
        <Spinner type="grow" color="primary" />
        <Spinner type="grow" color="secondary" />
        <Spinner type="grow" color="success" />
        <Spinner type="grow" color="danger" />
        <Spinner type="grow" color="warning" />
        <Spinner type="grow" color="info" />
        <Spinner type="grow" color="light" />
        <Spinner type="grow" color="dark" />
      </div>
    ) : null;

    const renderUlItem =
      this.state.addmissiontype === "Ikebana" ? (
        <ul>
          <li>Ikebana: Tk. 6,000/-</li>
        </ul>
      ) : this.state.addmissiontype === "Language" ? (
        <ul>
          <li>Special Conversation Course (1-3 months): Tk. 10,000/-</li>
          <li>Conversation Course (3 months): Tk. 10,000/-</li>
          <li>Comprehensive Japanese Language (6 months): Tk. 20,000/-</li>
        </ul>
      ) : null;

    return (
      <div>
        <PrintProvider>
          <NoPrint>
            <Print single name="foo">
              {this.state.done ? (
                <div>
                  <StudentDetails user={this.state} />
                </div>
              ) : (
                  <div></div>
                )}
            </Print>
            <h3 className="h3">Admission form</h3>
            <div className="container">
              <div className="form-item">
                <form role="form" onSubmit={this.handleSubmit}>
                  <div className="form-group">
                    <p>Select Admission Form: </p>
                    <select
                      name="addmissiontype"
                      className="form-control"
                      id="admissionType"
                      onChange={this.handleChange}
                      value={this.state.addmissiontype}
                    >
                      <option
                        className="form-control"
                        required="required"
                        value="Select"
                      >
                        {" "}
                        Select
                      </option>
                      <option
                        className="form-control"
                        required="required"
                        value="Ikebana"
                      >
                        Ikebana
                      </option>
                      <option
                        className="form-control"
                        required="required"
                        value="Language"
                      >
                        Japanese Language
                      </option>
                    </select>
                  </div>
                  <div className="form-group">
                    <p>Please Choose a Course:</p>
                    <select
                      name="course"
                      className="form-control"
                      id="choiceval"
                      onChange={this.handleChange}
                      disabled={this.state.selectCourse}
                    >
                      <option className="form-control" value="Select">
                        {" "}
                        Select
                      </option>
                      <option
                        className="form-control"
                        required="required"
                        value="Special Conversation course "
                      >
                        Special Conversation Course
                      </option>
                      <option
                        className="form-control"
                        required="required"
                        value="Conversation Course"
                      >
                        Conversation Course
                      </option>
                      <option
                        className="form-control"
                        required="required"
                        value="Comprehensive Japanese Language "
                      >
                        Comprehensive Japanese Language
                      </option>
                    </select>
                  </div>
                  <p>{renderUlItem}</p>
                  <br />
                  <h4 className="h4 text-center">Personal Information:</h4>
                  <div class="form-row mb-4">
                    <div class="col">
                      <label>Full Name:</label>
                      <input
                        type="text"
                        id="defaultRegisterFormFirstName"
                        class="form-control"
                        placeholder="Full Name"
                        name="name"
                        onChange={this.handleChange}
                        required="required"
                      />
                    </div>
                    <div class="col">
                      <label htmlFor="Name">Date of Birth:</label>
                      <input
                        type="date"
                        className="form-control"
                        id="bdayval"
                        name="b_day"
                        onChange={this.handleChange}
                        required="required"
                        name="b_day"
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>

                  <div class="form-row mb-4">
                    <div class="col">
                      <label htmlFor="Name">Father's Name:</label>
                      <input
                        type="name"
                        className="form-control"
                        id="fnameval"
                        name="f_name"
                        onChange={this.handleChange}
                        required="required"
                        placeholder="Father's Name:"
                      />
                    </div>
                    <div class="col">
                      <label htmlFor="Name">Mother's Name:</label>
                      <input
                        type="name"
                        className="form-control"
                        id="mnameval"
                        name="m_name"
                        onChange={this.handleChange}
                        required="required"
                        placeholder="Mother's Name:"
                      />
                    </div>
                  </div>

                  <div class="form-row mb-4">
                    <div class="col">
                      <label htmlFor="state_id" className="control-label">
                        Nationality:
                      </label>
                      <select
                        className="form-control"
                        id="nationval"
                        name="nationality"
                        onChange={this.handleChange}
                        required="required"
                      >
                        <option value="Bangladeshi">Select</option>
                        <option value="Bangladeshi">Bangladeshi</option>
                        <option value="Japanis">Japanese</option>
                        <option value="Chinise">Chinies</option>
                        <option value="Indian">Indian</option>
                      </select>
                    </div>
                    <div class="col">
                      <label htmlFor="Name">Occupation:</label>
                      <input
                        type="name"
                        className="form-control"
                        id="occoval"
                        name="occopation"
                        onChange={this.handleChange}
                        required="required"
                        placeholder="Occupation"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="address">Present Address:</label>
                    <input
                      type="address"
                      className="form-control"
                      id="preval"
                      name="address"
                      onChange={this.handleChange}
                      required="required"
                      placeholder="Present Address"
                    />
                  </div>
                  <label htmlFor="number">Contact info:</label>
                  <div class="form-row mb-4">
                    <div class="col">
                      <label htmlFor="tel">Tel:</label>
                      <input
                        type="text"
                        name="tel"
                        id="tnumbervarl"
                        placeholder="Tel"
                        onChange={this.handleChange}
                        className="form-control"
                      />
                    </div>
                    <div class="col">
                      <label htmlFor="cell">Cell:</label>
                      <input
                        type="text"
                        name="cell"
                        id="cnumberval"
                        placeholder="Cell"
                        onChange={this.handleChange}
                        className="form-control"
                      />
                    </div>
                    <div class="col">
                      <label htmlFor="email">Email:</label>
                      <input
                        type="email"
                        name="email"
                        id="cemailval"
                        placeholder="Email"
                        onChange={this.handleChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="address">Permanent Address:</label>
                    <input
                      type="address"
                      className="form-control"
                      id="peraddval"
                      name="p_address"
                      onChange={this.handleChange}
                      placeholder="Permanent Address"
                    />
                  </div>
                  <hr></hr>
                  <h4 className="h4 text-center">Academic Qualification:</h4>

                  <label htmlFor="address">SSC/Equivalent:</label>
                  <br />
                  <div class="form-row mb-4">
                    <div class="col">
                      <input
                        type="text"
                        name="ssc_p_year"
                        placeholder="Passing Year"
                        onChange={this.handleChange}
                        className="form-control"
                      />
                    </div>
                    <div class="col">
                      <input
                        type="text"
                        name="ssc_institute"
                        placeholder="Institute"
                        onChange={this.handleChange}
                        className="form-control"
                      />
                    </div>
                    <div class="col">
                      <input
                        type="text"
                        name="ssc_gpa"
                        placeholder="Division/GPA"
                        onChange={this.handleChange}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <label htmlFor="address">HSC/Equivalent:</label>
                  <br />
                  <div class="form-row mb-4">
                    <div class="col">
                      <input
                        type="text"
                        name="hsc_p_year"
                        placeholder="Passing Year"
                        onChange={this.handleChange}
                        className="form-control"
                      />
                    </div>
                    <div class="col">
                      <input
                        type="text"
                        name="hsc_institute"
                        placeholder="Institute"
                        onChange={this.handleChange}
                        className="form-control"
                      />
                    </div>
                    <div class="col">
                      <input
                        type="text"
                        name="hsc_gpa"
                        placeholder="Division/GPA"
                        onChange={this.handleChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <label className="control-label" htmlFor="sel2">
                    Proficiency in any other Foreign Language:
                  </label>
                  <br />

                  <div class="form-row mb-4">
                    <div class="col">
                      <select
                        name="languageProf"
                        id="tesNoVal"
                        onChange={this.handleChange}
                        className="form-control"
                      >
                        <option value="yes">Select</option>
                        <option value="yes" id="yes">
                          Yes
                        </option>
                        <option value="no" id="no">
                          No
                        </option>
                      </select>
                    </div>
                    <p>If Yes, write name</p>
                    <div class="col">
                      <input
                        type="text"
                        className=""
                        id="ifyesval"
                        name="language_proficiency"
                        onChange={this.handleChange}
                        className="form-control"
                      ></input>
                    </div>
                  </div>
                  <hr></hr>
                  <label htmlFor="address">
                    Upload Your Photo (Max: 600 x 600 pixels):
                  </label>
                  <br />
                  <div>
                    <input
                      ref="proImg"
                      type="file"
                      name="profile"
                      onChange={this.onProfilePicChange}
                    />
                  </div>
                  <img
                    src={profile}
                    width="250"
                    id="profile"
                    style={{ marginTop: "10px" }}
                  />
                  <br></br>
                  <hr></hr>
                  <label htmlFor="address">
                    Upload Money Receipt (Max: 600 x 600 pixels):
                  </label>
                  <br />
                  <div>
                    <input
                      type="file"
                      name="moneyReceipt"
                      onChange={this.onProfilePicChange}
                    />
                  </div>
                  <img
                    src={moneyReceipt}
                    width="250"
                    id="moneyReceipt"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  />
                  <br></br>

                  <div className="form-group">
                    <label htmlFor="message">
                      Why do you want to study Japanese?
                    </label>
                    <textarea
                      className="form-control"
                      rows="5"
                      id="comment"
                      name="study_japanese"
                      onChange={this.handleChange}
                    ></textarea>
                  </div>
                  <button type="submit" className="btn btn-success">
                    {" "}
                    Submit{" "}
                  </button>
                </form>
              </div>
            </div>
            <Modal show={this.state.done} size="lg">
              <Modal.Header style={{ color: "green" }}>
                <button
                  onClick={this.handleModelClose}
                  className="btn btn-primary"
                >
                  Close
                </button>
                Application Sent SucessFully{" "}
                <button onClick={this.handlePrint} className="btn btn-primary">
                  Print
                </button>{" "}
              </Modal.Header>
              <Modal.Body id="qr">
                <div className="container">
                  <div className="form-item">
                    <h4 style={{ textAlign: "center" }}>
                      {this.state.addmissiontype} Addmission Form
                    </h4>
                    <div class="form-row mb-4">
                      <div class="col">
                        <p>
                          Name: <span>{this.state.name}</span>
                        </p>
                        <p>
                          Father's Name: <span>{this.state.f_name}</span>
                        </p>
                        <p>
                          Mother's Name: <span>{this.state.m_name}</span>
                        </p>
                        <p>
                          Birth Date: <span>{this.state.b_day}</span>
                        </p>
                      </div>
                      <div class="col">
                        <img
                          src={profile}
                          height="150"
                          width="150"
                          style={{ marginLeft: "45%" }}
                        ></img>
                      </div>
                    </div>
                    <div class="form-row mb-4">
                      <div class="col">
                        <p>
                          Nationality: <span>{this.state.nationality}</span>
                        </p>
                      </div>
                      <div class="col">
                        <p>
                          Occopation: <span>{this.state.occopation}</span>
                        </p>
                      </div>
                    </div>

                    <div class="form-row mb-4">
                      <div class="col">
                        <p>
                          Present Address: <span>{this.state.address}</span>
                        </p>
                      </div>
                    </div>

                    <label htmlFor="number">Contact info:</label>

                    <div class="form-row mb-4">
                      <div class="col">
                        <p>
                          Tell: <span>{this.state.tel}</span>
                        </p>
                      </div>
                      <div class="col">
                        <p>
                          Cell: <span>{this.state.cell}</span>
                        </p>
                      </div>
                    </div>

                    <div class="form-row mb-4">
                      <div class="col">
                        <p>
                          Email: <span>{this.state.email}</span>
                        </p>
                      </div>
                    </div>

                    <div class="form-row mb-4">
                      <div class="col">
                        <p>
                          Permanent Address: <span>{this.state.p_address}</span>
                        </p>
                      </div>
                    </div>

                    <label htmlFor="number">Academic Qualification</label>
                    <br />
                    <label htmlFor="address">SSC/Equavilant:</label>
                    <br />
                    <div class="form-row mb-4">
                      <div class="col">
                        <p>
                          Passing Year: <span>{this.state.ssc_p_year}</span>
                        </p>
                      </div>
                      <div class="col">
                        <p>
                          Institute: <span>{this.state.ssc_institute}</span>
                        </p>
                      </div>
                      <div class="col">
                        <p>
                          GPA: <span>{this.state.ssc_gpa}</span>
                        </p>
                      </div>
                    </div>
                    <label htmlFor="address">HSC/Equavilant:</label>
                    <br />
                    <div class="form-row mb-4">
                      <div class="col">
                        <p>
                          Passing Year: <span>{this.state.hsc_p_year}</span>
                        </p>
                      </div>
                      <div class="col">
                        <p>
                          Institute: <span>{this.state.hsc_institute}</span>
                        </p>
                      </div>
                      <div class="col">
                        <p>
                          GPA: <span>{this.state.hsc_gpa}</span>
                        </p>
                      </div>
                    </div>

                    <label htmlFor="address">Money Recept:</label>
                    <br />
                    <img src={moneyReceipt} height="150" width="400"></img>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </NoPrint>
        </PrintProvider>
        <Modal show={this.state.Spinner}>
          <Modal.Body>{spinner}</Modal.Body>
        </Modal>
      </div>
    );
  }
}
export default Addmission;
